module.exports = __webpack_public_path__ + "static/media/home_hexagons.ef0082f7.png";